import { authenticatedApiFetch } from '../utils/utils'


export const allActivityEventsFilterService = async (filter) => {
    const res = await authenticatedApiFetch(`/activity-events/${filter}`, { method: 'GET' })
        .then(response => response.json())
        .catch(error => console.error(error))
    return res
}
